import videojs from 'video.js';

const Component = videojs.getComponent('Component');

const defaultOptions = {
  href: '',
  text: '',
  view: '',
  modificator: '',
  mobileBreakpoint: null
};


export default class Link extends Component {
  constructor(player, options) {
    super(player, options);
    this.options = videojs.mergeOptions(defaultOptions, options);
    this.player = player;
    if (this.options.view) {
      this.addClass(`vjs-link_view-${this.options.view}`);
    }
    if (this.options.modificator) {
      this.addClass(`vjs-link_${this.options.modificator}`);
    }
    this.setListeners();
  }

  setListeners() {
    this.player.one('play', () => {
      this.el().classList.remove('vjs-link_hide');
    });

    if (this.options.mobileBreakpoint) {
      const isMobileBreakpointList = Array.isArray(this.options.mobileBreakpoint);
      const mobileBreakpointList = isMobileBreakpointList ? this.options.mobileBreakpoint.slice(1) : [];

      let mobileBreakpoint = -1;
      if (typeof this.options.mobileBreakpoint === 'number') {
        mobileBreakpoint = this.options.mobileBreakpoint;
      } else if (isMobileBreakpointList) {
        mobileBreakpoint = this.options.mobileBreakpoint[0];
      }

      this.player.on('playerresize', () => {
        const playerWidth = this.player.currentWidth();
        const MOBILE_CLASS_NAME = 'vjs-link_mobile';

        if (playerWidth <= mobileBreakpoint) {
          this.addClass(MOBILE_CLASS_NAME);
          const breakpoint = mobileBreakpointList.find((breakpoint) => playerWidth >= breakpoint);
          if (breakpoint) {
            this.setAttribute('data-mobile-view', breakpoint);
          }
        } else {
          this.removeClass(MOBILE_CLASS_NAME);
          this.removeAttribute('data-mobile-view');
        }
      });
    }
  }

  createEl() {
    const el = videojs.createEl(
      'a',
      {
        className: 'vjs-link vjs-link_hide',
        href: this.options_.href,
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    );
    el.innerHTML = `<span class="vjs-link__text">${this.options_.text}</span>`;
    if (this.options_.view === 'matchtv') {
      el.innerHTML += `<img class="vjs-link__image" src="/images/embed/raccoon_matchtv.png" srcset="/images/embed/raccoon_matchtv_2x.png 1.5x" alt="Raccoon" />`;
    }
    return el;
  }
}

Component.registerComponent('Link', Link);
